import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppContext } from '../store/AppContext';
import SafeIcon from '../common/SafeIcon';
import { FiHome, FiUsers, FiSettings, FiLogOut, FiMenu } from 'react-icons/fi';

const Layout = ({ children }) => {
  const { logout, t } = useAppContext();
  const location = useLocation();

  const navItems = [
    { path: '/', icon: FiHome, label: 'dashboard' },
    { path: '/clients', icon: FiUsers, label: 'clients' },
    { path: '/settings', icon: FiSettings, label: 'settings' },
  ];

  return (
    <div className="flex h-screen bg-slate-50 font-sans">
      {/* Sidebar */}
      <aside className="w-64 bg-slate-900 text-slate-300 flex flex-col hidden md:flex">
        <div className="h-16 flex items-center px-6 border-b border-slate-800">
          <span className="text-xl font-bold text-white tracking-wider flex items-center gap-2">
            <span className="text-indigo-500">KW</span>Manager
          </span>
        </div>
        <nav className="flex-1 py-6 space-y-1 px-3">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-3 py-3 rounded-lg transition-colors ${
                location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))
                  ? 'bg-indigo-600 text-white'
                  : 'hover:bg-slate-800 hover:text-white'
              }`}
            >
              <SafeIcon icon={item.icon} className="mr-3 text-lg" />
              <span className="font-medium">{t(item.label)}</span>
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800">
          <button
            onClick={logout}
            className="flex items-center w-full px-3 py-2 text-sm text-slate-400 hover:text-white transition-colors"
          >
            <SafeIcon icon={FiLogOut} className="mr-3" />
            {t('logout')}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6">
          <div className="md:hidden">
            <SafeIcon icon={FiMenu} className="text-2xl text-slate-600" />
          </div>
          <div className="flex-1"></div>
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold">
              A
            </div>
          </div>
        </header>
        <div className="flex-1 overflow-auto p-6 md:p-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Layout;